import { RoutesEnum } from './routes.enum';
import { AllowedLangsEnum } from './locale.enum';

export const LOCALE_ROUTES_CONFIG: {[key in RoutesEnum]?: {[localeKey in AllowedLangsEnum]: string}} = {
  [RoutesEnum.PRICING]: {
    [AllowedLangsEnum.EN]: RoutesEnum.PRICING,
    [AllowedLangsEnum.DE]: 'preise',
    // [LocalePrefixesEnum.CH]: 'preise',
  },
  [RoutesEnum.ACCOUNTING]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ACCOUNTING,
    [AllowedLangsEnum.DE]: 'buchhaltung',
    // [LocalePrefixesEnum.CH]: 'buchhaltung',
  },
  [RoutesEnum.SERVICES]: {
    [AllowedLangsEnum.EN]: RoutesEnum.SERVICES,
    [AllowedLangsEnum.DE]: 'dienstleister',
    // [LocalePrefixesEnum.CH]: 'dienstleister',
  },
  [RoutesEnum.TRADE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.TRADE,
    [AllowedLangsEnum.DE]: 'warenwirtschaftssoftware',
    // [LocalePrefixesEnum.CH]: RoutesEnum.TRADE',
  },
  [RoutesEnum.ECOMMERCE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ECOMMERCE,
    [AllowedLangsEnum.DE]: 'e-commerce',
    // [LocalePrefixesEnum.CH]: RoutesEnum.ECOMMERCE',
  },
  [RoutesEnum.WAREHOUSE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.WAREHOUSE,
    [AllowedLangsEnum.DE]: 'lagerverwaltung',
    // [LocalePrefixesEnum.CH]: 'lagerverwaltung',
  },
  [RoutesEnum.PRODUCTS]: {
    [AllowedLangsEnum.EN]: RoutesEnum.PRODUCTS,
    [AllowedLangsEnum.DE]: 'artikelverwaltung',
    // [LocalePrefixesEnum.CH]: 'artikelverwaltung',
  },
  [RoutesEnum.PARTNERS]: {
    [AllowedLangsEnum.EN]: RoutesEnum.PARTNERS,
    [AllowedLangsEnum.DE]: 'kundenverwaltung',
    // [LocalePrefixesEnum.CH]: 'kundenverwaltung',
  },
  [RoutesEnum.TEAM]: {
    [AllowedLangsEnum.EN]: RoutesEnum.TEAM,
    [AllowedLangsEnum.DE]: 'personalwesen',
    // [LocalePrefixesEnum.CH]: 'personalwesen',
  },
  [RoutesEnum.RETAIL]: {
    [AllowedLangsEnum.EN]: RoutesEnum.RETAIL,
    [AllowedLangsEnum.DE]: 'kassensystem',
    // [LocalePrefixesEnum.CH]: 'kassensystem',
  },
  [RoutesEnum.PRIVACY_POLICY]: {
    [AllowedLangsEnum.EN]: RoutesEnum.PRIVACY_POLICY,
    [AllowedLangsEnum.DE]: 'datenschutzerklaerung',
    // [LocalePrefixesEnum.CH]: 'datenschutzerklaerung',
  },
  [RoutesEnum.TERMS_OF_SERVICE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.TERMS_OF_SERVICE,
    [AllowedLangsEnum.DE]: 'agb',
    // [LocalePrefixesEnum.CH]: 'agb',
  },
  [RoutesEnum.COOKIE_POLICY]: {
    [AllowedLangsEnum.EN]: RoutesEnum.COOKIE_POLICY,
    [AllowedLangsEnum.DE]: 'cookie-erklaerung',
    // [LocalePrefixesEnum.CH]: 'cookie-erklaerung',
  },
  [RoutesEnum.ABOUT]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ABOUT,
    [AllowedLangsEnum.DE]: 'ueber-runple',
    // [LocalePrefixesEnum.CH]: 'ueber-runple',
  },
  [RoutesEnum.LEGAL]: {
    [AllowedLangsEnum.EN]: RoutesEnum.LEGAL,
    [AllowedLangsEnum.DE]: 'impressum',
    // [LocalePrefixesEnum.CH]: 'impressum',
  },
  [RoutesEnum.LEXICON]: {
    [AllowedLangsEnum.EN]: RoutesEnum.LEXICON,
    [AllowedLangsEnum.DE]: 'lexikon',
    // [LocalePrefixesEnum.CH]: 'lexikon',
  },
  [RoutesEnum.BLOG]: {
    [AllowedLangsEnum.EN]: RoutesEnum.BLOG,
    [AllowedLangsEnum.DE]: RoutesEnum.BLOG,
    // [LocalePrefixesEnum.CH]: RoutesEnum.BLOG,
  },
  [RoutesEnum.ACCOUNTING_SOFTWARE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ACCOUNTING_SOFTWARE,
    [AllowedLangsEnum.DE]: 'loesungen-buchhaltungssoftware',
    // [LocalePrefixesEnum.CH]: RoutesEnum.ACCOUNTING_SOFTWARE,
  },
  [RoutesEnum.INVENTORY_MANAGEMENT]: {
    [AllowedLangsEnum.EN]: RoutesEnum.INVENTORY_MANAGEMENT,
    [AllowedLangsEnum.DE]: 'warenwirtschaftssoftware',
    // [LocalePrefixesEnum.CH]: RoutesEnum.INVENTORY_MANAGEMENT,
  },
  [RoutesEnum.ECOMMERCE_SOFTWARE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ECOMMERCE_SOFTWARE,
    [AllowedLangsEnum.DE]: 'loesungen-e-commerce-software',
    // [LocalePrefixesEnum.CH]: RoutesEnum.ECOMMERCE_SOFTWARE,
  },
  [RoutesEnum.POINT_OF_SALE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.POINT_OF_SALE,
    [AllowedLangsEnum.DE]: 'loesungen-kassensystem',
    // [LocalePrefixesEnum.CH]: RoutesEnum.POINT_OF_SALE,
  },
    [RoutesEnum.SALES]: {
    [AllowedLangsEnum.EN]: RoutesEnum.SALES,
    [AllowedLangsEnum.DE]: 'vertrieb',
    // [LocalePrefixesEnum.CH]: RoutesEnum.POINT_OF_SALE,
  },
    [RoutesEnum.TIME_TRACKING]: {
    [AllowedLangsEnum.EN]: RoutesEnum.TIME_TRACKING,
    [AllowedLangsEnum.DE]: 'zeiterfassung',
    // [LocalePrefixesEnum.CH]: RoutesEnum.POINT_OF_SALE,
  },
  [RoutesEnum.BLOG_PAGE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.BLOG_PAGE,
    [AllowedLangsEnum.DE]: RoutesEnum.BLOG_PAGE,
    // [LocalePrefixesEnum.CH]: RoutesEnum.BLOG_PAGE,
  },
  [RoutesEnum.LEXICON_PAGE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.LEXICON_PAGE,
    [AllowedLangsEnum.DE]: 'lexikon/:postName',
    // [LocalePrefixesEnum.CH]: RoutesEnum.LEXICON_PAGE,
  },
  [RoutesEnum.AUTHOR_PAGE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.AUTHOR_PAGE,
    [AllowedLangsEnum.DE]: RoutesEnum.AUTHOR_PAGE,
    // [LocalePrefixesEnum.CH]: RoutesEnum.AUTHOR_PAGE,
  },
  [RoutesEnum.START]: {
    [AllowedLangsEnum.EN]: RoutesEnum.START,
    [AllowedLangsEnum.DE]: RoutesEnum.START,
    // [LocalePrefixesEnum.CH]: RoutesEnum.START,
  },
  [RoutesEnum.ANALYTICS]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ANALYTICS,
    [AllowedLangsEnum.DE]: 'business-intelligence',
    // [LocalePrefixesEnum.CH]: RoutesEnum.ANALYTICS,
  },
  [RoutesEnum.WELCOME]: {
    [AllowedLangsEnum.EN]: RoutesEnum.WELCOME,
    [AllowedLangsEnum.DE]: 'willkommen',
    // [LocalePrefixesEnum.CH]: RoutesEnum.WELCOME,
  },
  [RoutesEnum.TRADE_SEO]: {
    [AllowedLangsEnum.EN]: RoutesEnum.TRADE_SEO,
    [AllowedLangsEnum.DE]: RoutesEnum.TRADE_SEO,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.TRADE_SEO,
  },
  [RoutesEnum.ECOMMERCE_SEO]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ECOMMERCE_SEO,
    [AllowedLangsEnum.DE]: RoutesEnum.ECOMMERCE_SEO,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.ECOMMERCE_SEO,
  },
  [RoutesEnum.ACCOUNTING_SEO]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ACCOUNTING_SEO,
    [AllowedLangsEnum.DE]: RoutesEnum.ACCOUNTING_SEO,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.ACCOUNTING_SEO,
  },
  [RoutesEnum.RETAIL_SEO]: {
    [AllowedLangsEnum.EN]: RoutesEnum.RETAIL_SEO,
    [AllowedLangsEnum.DE]: RoutesEnum.RETAIL_SEO,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.RETAIL_SEO,
  },
  [RoutesEnum.SERVICE_SEO]: {
    [AllowedLangsEnum.EN]: RoutesEnum.SERVICE_SEO,
    [AllowedLangsEnum.DE]: RoutesEnum.SERVICE_SEO,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.SERVICE_SEO,
  },
  [RoutesEnum.ERP_SOFTWARE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ERP_SOFTWARE,
    [AllowedLangsEnum.DE]: RoutesEnum.ERP_SOFTWARE,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.ERP_SOFTWARE,
  },
  [RoutesEnum.RUNPLE_FREE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.RUNPLE_FREE,
    [AllowedLangsEnum.DE]: RoutesEnum.RUNPLE_FREE,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.RUNPLE_FREE,
  },
  [RoutesEnum.ONLINE_STORE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.ONLINE_STORE,
    [AllowedLangsEnum.DE]: RoutesEnum.ONLINE_STORE,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.ONLINE_STORE,
  },
  [RoutesEnum.CREATE_USER]: {
    [AllowedLangsEnum.EN]: RoutesEnum.CREATE_USER,
    [AllowedLangsEnum.DE]: RoutesEnum.CREATE_USER,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.CREATE_USER,
  },
  [RoutesEnum.NOT_PAGE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.NOT_PAGE,
    [AllowedLangsEnum.DE]: RoutesEnum.NOT_PAGE,
    // [LocalePrefixesEnum.CH]: RoutesEnum.RoutesEnum.NOT_PAGE,
  },
  [RoutesEnum.OFFER]: {
    [AllowedLangsEnum.EN]: RoutesEnum.OFFER,
    [AllowedLangsEnum.DE]: RoutesEnum.OFFER,
    // [LocalePrefixesEnum.CH]: RoutesEnum.OFFER,
  },
  [RoutesEnum.SAAS]: {
    [AllowedLangsEnum.EN]: RoutesEnum.SAAS,
    [AllowedLangsEnum.DE]: RoutesEnum.SAAS,
    // [LocalePrefixesEnum.CH]: RoutesEnum.SAAS,
  },
  [RoutesEnum.SIGN_IN]: {
    [AllowedLangsEnum.EN]: RoutesEnum.SIGN_IN,
    [AllowedLangsEnum.DE]: 'einloggen',
    // [LocalePrefixesEnum.CH]: RoutesEnum.SIGN_IN,
  },
  [RoutesEnum.WORKSPACE_CREATED]: {
    [AllowedLangsEnum.EN]: RoutesEnum.WORKSPACE_CREATED,
    [AllowedLangsEnum.DE]: 'arbeitsbereich',
    // [LocalePrefixesEnum.CH]: RoutesEnum.WORKSPACE_CREATED,
  },
  [RoutesEnum.RELEASE_NOTES]: {
    [AllowedLangsEnum.EN]: RoutesEnum.RELEASE_NOTES,
    [AllowedLangsEnum.DE]: 'versionshinweise',
    // [LocalePrefixesEnum.CH]: RoutesEnum.RELEASE_NOTES,
  },
  [RoutesEnum.SURVEY]: {
    [AllowedLangsEnum.EN]: RoutesEnum.SURVEY,
    [AllowedLangsEnum.DE]: RoutesEnum.SURVEY,
  },
  [RoutesEnum.NOT_AVAILABLE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.NOT_AVAILABLE,
    [AllowedLangsEnum.DE]: 'nicht-verfugbar',
  },
  [RoutesEnum.EMAIL_SUBSCRIPTION]: {
    [AllowedLangsEnum.EN]: RoutesEnum.EMAIL_SUBSCRIPTION,
    [AllowedLangsEnum.DE]: RoutesEnum.EMAIL_SUBSCRIPTION,
  },
  [RoutesEnum.SERVICE]: {
    [AllowedLangsEnum.EN]: RoutesEnum.SERVICE,
    [AllowedLangsEnum.DE]: RoutesEnum.SERVICE,
  },
};
